<template>
  <div class="PersonelMonthWork">
    <section-month-search-panel @search="search" />

    <box class="mt-2" :title="$t('personelList')">
      <template slot="top-action-view">
        <v-icon
          v-if="list.length > 0 && visiblePrint"
          @click="print"
          color="white"
          >mdi-printer</v-icon
        >
      </template>
      <div v-if="list.length > 0">
        <monthly-functionality-list-web
          :list="list"
          class="hidden-sm-and-down"
          @onClick="onClick"
        />
        <monthly-functionality-list-mob
          :list="list"
          class="hidden-md-and-up"
          @onClick="onClick"
        />
      </div>
      <div v-else>
        <empty-list :state="functionStateList" />
      </div>
    </box>

    <!-- <period-work v-if="!isWebKartAdmin" class="mt-2" :periodWork="periodWork" /> -->
  </div>
</template>

<script>
//import PeriodWork from "../../components/functionality/period/PeriodWork.vue";
import MonthlyFunctionalityListMob from "../../components/personelOperationReport/personelMonthWork/MonthlyFunctionalityListMob.vue";
import MonthlyFunctionalityListWeb from "../../components/personelOperationReport/personelMonthWork/MonthlyFunctionalityListWeb.vue";
import SectionMonthSearchPanel from "../../components/personelOperationReport/SectionMonthSearchPanel.vue";
import EosToastType from "../../model/EosToastType";
import EosUtils from "../../utils/EosUtils";
import TextUtils from "../../utils/TextUtils";
import StateList from "../../model/StateList";
export default {
  components: {
    //PeriodWork,
    MonthlyFunctionalityListWeb,
    MonthlyFunctionalityListMob,
    SectionMonthSearchPanel,
  },
  data() {
    return {
      periodWork: {},
      list: [],
      period: "",
      year: "",
      functionStateList: null,
      isWebKartAdmin: false,
      visiblePrint: false,
      sectioncode: "",
    };
  },
  mounted() {
    this.isWebKartAdmin = EosUtils.isWebKartAdmin();
  },
  methods: {
    search(searchParams) {
      if (!searchParams.year || !searchParams.month) {
        return;
      }
      this.list = [];
      this.functionStateList = StateList.loading();

      this.period = searchParams.month;
      this.year = searchParams.year;
      this.sectioncode = searchParams.sectioncode;

      const params = new URLSearchParams();
      params.append("month", searchParams.month);
      params.append("year", searchParams.year);
      params.append("sectioncode", searchParams.sectioncode);
      params.append("isperiod", false);

      this.$store
        .dispatch("GetPersonelMonthWork", { params })
        .then((result) => {
          //console.log(result);
          if (result.type === "success") {
            this.list = result.data.Table;
            this.functionStateList = null;
            this.checkVisiblePrint();
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || this.$t("operationFailed"),
            });
            this.functionStateList = StateList.error(result.error);
          }
        })
        .catch((error) => {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: `${error}`,
          });
          this.functionStateList = StateList.error(error);
        });
    },
    onClick(item) {
      //console.log(item);
      if (EosUtils.isWebKartAdmin()) {
        this.$router.push({
          name: "adminMonthWorkDetails",
          params: {
            month: this.period,
            year: this.year,
            perno: TextUtils.convertToEnglishDigits(item.PERNO.trim()),
          },
        });
      } else {
        this.$router.push({
          name: "MonthWorkDetails",
          params: {
            month: this.period,
            year: this.year,
            perno: TextUtils.convertToEnglishDigits(item.PERNO.trim()),
          },
        });
      }
    },
    checkVisiblePrint() {
      if (EosUtils.isWebKartAdmin()) {
        this.visiblePrint = true;
      } else {
        var adminPermissionList =
          this.$store.state.personel.personelDetail.AdminPermission.Table;
        adminPermissionList.every((element) => {
          var adminPermission = element.adminPermission;
          if (adminPermission && adminPermission[50].toString() == "1") {
            this.visiblePrint = true;
            return false;
          }
          return true;
        });
      }
    },
    print() {
      let routeData = this.$router.resolve({
        name: "rpPersonelPeriodWork",
        query: { SC: this.sectioncode, Y: this.year, POM: "M", P: this.period },
      });
      window.open(routeData.href, "_blank");
    },
    /*search(searchParams) {
      const params = new URLSearchParams();
      params.append("month", searchParams.month);
      params.append("year", searchParams.year);

      this.$store
        .dispatch("GetPersonMonthWork", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            var data = [];
            data = result.data;
            if (data.length > 0) {
              this.periodWork = data[0];
              this.periodWork.year = params.year;
              this.periodWork.period = params.month;
            }
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
          }
        })
        .catch((error) => {
          this.$EosToast.show({
              type: EosToastType.error,
              msg: `${error}`,
            });
        });
    },*/
  },
};
</script>

<style>
</style>